module.exports = __webpack_public_path__ + "static/media/chargingSoldiers.db63b4d7.jpg";